export default __webpack_public_path__ + "static/神州数码-90df975453eba320b02a1f1e00a7661d.png";